import { defineComponent as _defineComponent } from 'vue';
import { BTab, BTabs } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useConfigurationTemplateEdit } from "@/components/ConfigTemplates/useConfigurationTesting";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import { useInstanceAndTemplate } from "./instance";
import { useInstanceRouting } from "./routing";
import EditSecrets from "./EditSecrets.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditInstance',
    props: {
        instanceId: null
    },
    setup(__props) {
        const props = __props;
        const editTestUrl = "/api/object_store_instances/{uuid}/test";
        const editUrl = "/api/object_store_instances/{uuid}";
        const { addOrUpdateObjectStore } = useObjectStoreStore();
        const { instance, template } = useInstanceAndTemplate(ref(props.instanceId));
        const title = computed(() => `Edit Storage Location ${instance.value?.name} Settings`);
        const errorDataDescription = "object-store-update-error";
        const { error, hasSecrets, ActionSummary, inputs, InstanceForm, loadingMessage, onForceSubmit, onSubmit, testRunning, testResults, showForceActionButton, submitTitle, } = useConfigurationTemplateEdit("storage location", instance, template, editTestUrl, editUrl, useInstanceRouting, addOrUpdateObjectStore);
        return { __sfc: true, editTestUrl, editUrl, addOrUpdateObjectStore, props, instance, template, title, errorDataDescription, error, hasSecrets, ActionSummary, inputs, InstanceForm, loadingMessage, onForceSubmit, onSubmit, testRunning, testResults, showForceActionButton, submitTitle, BTab, BTabs, EditSecrets };
    }
});
